import { BrowserRouter } from "react-router-dom";
import Header from "./components/Header";
import Hero from "./sections/Hero";
import SectionBreak from "./components/SectionBreak";
import Services from "./sections/Services";
import Prices from "./sections/Prices";
import AboutUs from "./sections/AboutUs";
import Reviews from "./sections/Reviews";
import Partners from "./sections/Partners";
import Contact from "./sections/Contact";
import Footer from "./sections/Footer";


function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <div id='home'>

          <Header />
          <Hero />
        </div>
        <SectionBreak />
        <Services />
        <div id="prices">

          <SectionBreak />
          <Prices />
        </div>
        <div id="about-us">

          <SectionBreak />
          <AboutUs />
        </div>
        <SectionBreak />
        <Reviews />
        <SectionBreak />
        <Partners />
        <SectionBreak />
        <Contact />
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
